import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { RecurringPaymentInstruction } from '../../../../../../../models/submissions/recurring-payment-instruction';
import { VariableBenefitPaymentFrequencyEnum } from 'src/app/models/enum/shared/variable-benefit-payment-frequency.enum';

@Component({
  selector: 'app-vb-payment-change-submission-active-payment',
  templateUrl: './vb-payment-change-submission-active-payment.component.html',
  styleUrls: ['../vb-payment-change-submission-recurring-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VbPaymentChangeSubmissionActivePaymentComponent implements OnChanges {
  @Input({ required: true }) frequency!: VariableBenefitPaymentFrequencyEnum;
  @Input({ required: true }) activeRecurringPaymentInstruction!: RecurringPaymentInstruction;

  public paymentAmountType = '';
  public paymentLabel = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeRecurringPaymentInstruction || changes.frequency) {
      this.paymentAmountType = this.activeRecurringPaymentInstruction?.useMinimumAmount
        ? $localize`Minimum`
        : $localize`Custom`;

      if (this.frequency === VariableBenefitPaymentFrequencyEnum.Annually) {
        this.paymentLabel = $localize`${moment
          .utc(this.activeRecurringPaymentInstruction?.paymentStartDate)
          .format('MMMM')} Payments`;
      }
    }
  }

  protected readonly VariableBenefitPaymentFrequencyEnum = VariableBenefitPaymentFrequencyEnum;
}
